<template>
  <v-select
    v-model="strategy"
    :items="ringStrategiesFormatted"
    item-value="strategy"
    item-text="localizedName"
    prepend-icon="mdi-bell-ring"
    :label="$t('settings.fme.ringStrategy.label')"
    chips
  >
    <template v-slot:append-outer>
      <cp-help i18n="followme.strategies"/>
    </template>
  </v-select>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'settings-followme-ring-strategies',
  computed: {
    ...mapGetters({
      followme: 'settings/followme',
      ringStrategies: 'ringStrategies/ringStrategies'
    }),
    ringStrategiesFormatted () {
      return this.ringStrategies?.map((ringStrategy) => {
        return {
          name: ringStrategy.name,
          strategy: ringStrategy.strategy,
          localizedName: this.$t('settings.fme.ringStrategy.strategies.' + ringStrategy.strategy)
        }
      })
    },
    getStrategy () {
      return this.followme?.strategy
    },
    strategy: {
      get () {
        return this.getStrategy
      },
      set (strategy) {
        this.setFollowmeStrategy(strategy)
      }
    }
  },
  methods: {
    ...mapActions({
      setFollowmeStrategy: 'settings/setFollowmeStrategy'
    })
  }
}
</script>

<style></style>
